import { combineReducers } from 'redux';
import table from './table.reducer';

const reducer = combineReducers({
	table
});

export default reducer;